import { getCookie } from "../actions";
import { AnalyticParams } from "../constants";
import { validateAnalyticsParam } from "../utils";

export const getFBPAnalyticsParam = () => {
  const cookie = getCookie(AnalyticParams.FBP);

  return validateAnalyticsParam(null, cookie);
};
